import { ConvertListPage } from "@/features/convert/pages/ConvertList";
import React from "react";

function ConvertList() {
  return <ConvertListPage />;
}

export default ConvertList;
